<template>
    <!-- 전체 콘텐츠 영역 -->
      <div class="main-contents">
        <div class="news_wrap">
          <div class="path"><a href="javascript:void(0);" @click="$router.go(-1)">◀ 목록가기</a></div>

          <!-- view -->
          <div class="news-view">
            <div class="view-title">[ 그레이트프로 뉴스 ] {{newsInfo.newsCenterTitle}}</div>
            <div class="attatched-image ta-left" v-if="newsInfo.attaFileSeq">
              <!-- <img :src="'/api/main/bbs/noticeImage?attaFileSeq='+noticeInfo.attaFileSeq" :alt="noticeInfo.attaFileNm" /> -->
              <ImageComp :src="'/api/main/bbs/newsCenterImage?attaFileSeq='+newsInfo.attaFileSeq" alt="공지사항 이미지"/>
            </div>
            <div v-if="newsInfo.newsCenterCont" class="ql-snow">
                <div class="view-text ql-editor">
                    <QuillContentViewer
                      :contentData="newsInfo.newsCenterCont"
                      :metaDataYn="true"
                      @metaDataReady="handleMetaData"
                    />
                </div>
            </div>
          </div>

        </div>
      </div>
</template>

<script>
import { newsDetailMeta } from '@/utils/meta';
import QuillContentViewer from '@/components/QuillContentViewer.vue';

export default {
    components: { QuillContentViewer },
    data () {
        return {
            newsCenterSeq : this.$route.query.no || '',
            newsInfo : {
                attaFileSeq : '',
                attaFileNm : '',
                newsCenterTitle : '',
                newsCenterCont : '',
            },
            
            metaContData : ''
        }
    },

    beforeMount() {
        this.getNewsDetail();
    },
    
    methods: {
        getNewsDetail() {
            this.$.httpPost('/api/main/bbs/getNewsDetail', {newsCenterSeq: this.newsCenterSeq})
            .then(res=>{
                    this.newsInfo = res.data.info;

            }).catch(this.$.httpErrorCommon);
        },
        
        handleMetaData(metaData) {
            this.metaContData = metaData;
        }
    },

    metaInfo() {
      return newsDetailMeta(this.newsInfo.newsCenterTitle, this.metaContData);
    }
}
</script>